export type UserRole = "admin" | "host" | "cleaner" | "field_agent";
export type UserStatus = "active" | "suspended" | "pending_kyc" | "pending_email_verification" | "deactivated";
export type PropertyType = "apartment" | "house" | "office" | "commercial" | "other";
export type PropertyStatus = "active" | "inactive" | "archived";
export type JobStatus =
  | "awaiting_payment"
  | "open"
  | "accepted"
  | "in_progress"
  | "completion_submitted"
  | "completed"
  | "disputed"
  | "cancelled"
  | "expired";
export type CleaningType = "standard" | "deep" | "move_in" | "move_out" | "post_construction" | "other";
export type JobUrgency = "normal" | "urgent";
export type WalletTxType = "deposit" | "lock" | "unlock" | "payout" | "fee" | "commission" | "refund" | "withdrawal" | "reversal" | "adjustment";
export type WalletTxStatus = "pending" | "completed" | "failed" | "reversed";
export type KycStatus = "pending" | "approved" | "rejected" | "expired" | "resubmitted";
export type ReferralStatus = "pending" | "kyc_submitted" | "kyc_approved" | "commission_paid" | "rejected";
export type NotificationChannel = "email" | "sms" | "whatsapp" | "in_app" | "push";
export type NotificationStatus = "pending" | "sent" | "delivered" | "failed" | "read";
export type PaymentGateway = "paystack" | "pesapal" | "mpesa" | "manual";
export type PaymentOrderKind = "wallet_deposit" | "job_payment";
export type PaymentOrderStatus = "pending" | "initiated" | "success" | "failed" | "cancelled" | "refunded";
export type DisputeStatus = "open" | "under_review" | "resolved_favor_host" | "resolved_favor_cleaner" | "withdrawn" | "escalated";
export type DisputeCategory = "quality" | "damage" | "theft" | "safety" | "payment" | "other";
export type DisputeRaiserRole = "host" | "cleaner" | "admin";
export type JobEvidenceType = "before" | "after" | "issue" | "other";
export type AuditSeverity = "debug" | "info" | "warning" | "critical" | "security";
export type UploadPurpose = "kyc_document" | "property_image" | "avatar" | "job_evidence" | "dispute_evidence";
export type DevicePlatform = "web" | "ios" | "android";
export type WithdrawalStatus = "requested" | "processing" | "success" | "failed" | "reconciliation_required" | "cancelled";
export type RefundStatus = "requested" | "processing" | "success" | "failed" | "reconciliation_required";
export type JobIssueCategory = "access" | "safety" | "condition" | "lateness" | "transport" | "host_unreachable" | "other";
export type JobIssueSeverity = "normal" | "high" | "critical";
export type JobIssueStatus = "open" | "acknowledged" | "resolved" | "closed";
export type ExtraWorkStatus = "pending" | "approved" | "declined" | "cancelled";
export type AccountSetupPurpose = "agent_invite" | "cleaner_setup";

export const JOB_TRANSITIONS: Record<JobStatus, JobStatus[]> = {
  awaiting_payment: ["open", "cancelled", "expired"],
  open: ["accepted", "cancelled", "expired"],
  accepted: ["in_progress", "cancelled"],
  in_progress: ["completion_submitted", "disputed", "cancelled"],
  completion_submitted: ["completed", "disputed", "cancelled"],
  completed: ["disputed"],
  disputed: ["completed", "completion_submitted"],
  cancelled: [],
  expired: [],
};

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: "Administrator", host: "Host", cleaner: "Cleaner", field_agent: "Field Agent",
};

export const JOB_STATUS_LABELS: Record<JobStatus, string> = {
  awaiting_payment: "Awaiting Payment", open: "Open", accepted: "Accepted",
  in_progress: "In Progress", completion_submitted: "Completion Submitted",
  completed: "Completed", disputed: "Disputed", cancelled: "Cancelled",
  expired: "Expired",
};

export const CLEANING_TYPE_LABELS: Record<CleaningType, string> = {
  standard: "Standard Cleaning", deep: "Deep Cleaning", move_in: "Move-In Cleaning",
  move_out: "Move-Out Cleaning", post_construction: "Post-Construction", other: "Other",
};

export const PROPERTY_TYPE_LABELS: Record<PropertyType, string> = {
  apartment: "Apartment", house: "House", office: "Office", commercial: "Commercial", other: "Other",
};

export const KYC_STATUS_LABELS: Record<KycStatus, string> = {
  pending: "Pending Review", approved: "Approved", rejected: "Rejected", expired: "Expired", resubmitted: "Resubmission Required",
};

export const WITHDRAWAL_STATUS_LABELS: Record<WithdrawalStatus, string> = {
  requested: "Requested", processing: "Processing", success: "Paid",
  failed: "Failed", reconciliation_required: "Needs Review", cancelled: "Cancelled",
};

export const JOB_ISSUE_CATEGORY_LABELS: Record<JobIssueCategory, string> = {
  access: "Can't access property", safety: "Safety issue", condition: "Property condition",
  lateness: "Running late", transport: "Transport issue", host_unreachable: "Host unreachable",
  other: "Other issue",
};

export const DISPUTE_CATEGORY_LABELS: Record<DisputeCategory, string> = {
  quality: "Cleaning quality", damage: "Damage", theft: "Theft",
  safety: "Safety", payment: "Payment", other: "Other",
};
